export function EventInvoicesCtrl ($state, $scope, $translate, workshopAPI) {
  $scope.showEventInvoices = !!$scope.invoices.length;

  $scope.tableSettings = {
    columns: [
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('JS_SPACE.BOOKINGS.INVOICE_HASH')
        }
      },
      {
        field : 'job_card_number',
        header: {
          text: $translate.instant('JS_SPACE.BOOKINGS.JOB_HASH')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'invoice_status',
        header: {
          text: $translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.SUPPORT.INVOICE_STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'job_status',
        header: {
          text: $translate.instant('INVOICE_SPACE.JOB_STATUS')
        },
        pipe    : 'jobStatus',
        pipeArgs: [ $scope.jobStatusTypes ]
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/events/invoice_count_for_event', $scope.event.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    }
  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/events/invoices_for_event_list', [
      $scope.event.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.invoice', {
      customer_id: event.row.customer_id,
      vehicle_id : event.row.vehicle_id,
      id         : event.row.id
    });
  };
}